import React from 'react';
import { Link } from 'react-router-dom';
import { conferences } from '../data/conferences';
import { Container, Card, Button, Row, Col } from 'react-bootstrap';
import Footer from '../components/Footer';

// Helper function to get a short description from the post content
const getShortDescription = (content) => {
    const textItem = content.find(item => item.Type === 'Text');
    if (textItem && textItem.text) {
        // Return the first 150 characters
        return textItem.text.substring(0, 150) + '...';
    }
    return 'No description available.';
};

const NewsUpdates = () => {
    return (
        <>
        <div className="hero-section text-center text-white" style={{
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('/static/OT-Surgery-3-scaled.webp')`, // Replace with your hero image
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                padding: '100px 0',
                minHeight: '40vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                <Container>
                    <h1 className="display-3 font-weight-bold mb-4">Empowering Surgeons, Advancing Healthcare</h1>
                    <p className="lead mb-5" style={{ maxWidth: '700px', margin: '0 auto 2rem auto' }}>
                        Leaders in Laparoscopic Surgery Training
                    </p>
                    <div>
                        <Link to="/register">
                            <Button variant="primary" size="lg" className="me-3 px-5 py-3">Get Started</Button>
                        </Link>
                        <Link to="/training-programs"> {/* Or any other relevant link */}
                            <Button variant="outline-light" size="lg" className="px-5 py-3">Learn More</Button>
                        </Link>
                    </div>
                </Container>
            </div>
            <Container className="post-list-page mt-4">
                <h1 className="list-title mb-5">Blog</h1>

                <Row>
                    {conferences.map((conference) => (
                        // Responsive columns: 1 on extra-small, 2 on small, 3 on medium screens and up
                        <Col xs={12} sm={6} md={4} key={conference.id} className="mb-4 d-flex">
                            <Card className="h-100 w-100">
                                <Card.Img
                                    variant="top"
                                    src={conference.MainImage}
                                    alt={conference.Title}
                                    className="card-img-top"
                                />
                                <Card.Body className="d-flex flex-column">
                                    <p className="card-category">CONFERENCES & WORKSHOPS</p>
                                    <Card.Title className="h5">{conference.Title}</Card.Title>
                                    <div className="ms-auto mt-auto">
                                        <Link to={`/news-updates/${conference.id}`}>
                                            <Button variant="primary" size="sm">Read more</Button>
                                        </Link>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Container>

            <Footer />
        </>
    );
};

export default NewsUpdates;